import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getCultureCode } from '~shared/utils/betGenius/utils';
import { useBrandedBgVisualisationConfig } from '~SpectateStore/hooks/clientStateHooks';
import { useSportSlugByEventId } from '~SpectateStore/hooks/sportsHooks';
import {
    useBetGeniusScriptUrl,
    useBetGeniusSportUrl,
} from '~SpectateStore/hooks/scoreboardHooks';

const BetGeniusVisualization = ({ eventId, updateStatusCallback }) => {
    const sportSlug = useSportSlugByEventId(eventId);
    const scriptUrl = useBetGeniusScriptUrl();
    const sportUrl = useBetGeniusSportUrl(eventId);
    const brandedName = useBrandedBgVisualisationConfig();
    const widgetWrapperRef = useRef();
    const [iFrameUrl, setIFrameUrl] = useState(null);
    const wrapperClassNames = classNames('betgenius', 'scorecentre', 'mobile', sportSlug);

    useEffect(() => {
        if (sportUrl) {
            // Replace string parameters in the sport iframe url:
            // e.g. "?eventId=bgEventId&culture=bgIso"
            const params= {
                bgEventId: eventId,
                bgIso: getCultureCode(),
                brandName: brandedName,
            };

            setIFrameUrl(sportUrl.replace(/bgEventId|bgIso|brandName/gi, matched => params[matched]));
        }
    }, [sportUrl]);

    useEffect(() => {
        const script = document.createElement('script');

        if (widgetWrapperRef.current) {
            // Calling updateStatusCallback here is to make the BetGenius component act the same
            // way as the SportRadar component which sends a callback once it's ready.
            updateStatusCallback(false);
            script.src = scriptUrl;
            script.async = true;
            widgetWrapperRef.current.appendChild(script);
        }

        return () => {
            widgetWrapperRef.current.removeChild(script);
        };
    }, [widgetWrapperRef.current]);

    if (!sportUrl) {
        updateStatusCallback(true);

        return null;
    }

    return (
        <div
            className={wrapperClassNames}
            ref={widgetWrapperRef}>
            <iframe
                src={iFrameUrl}
                width="100%"
                height="100%"
                id="betgenius-iframe"
                scrolling='no'
            />
        </div>
    );
};

BetGeniusVisualization.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    updateStatusCallback: PropTypes.func,
};

export default BetGeniusVisualization;
